'use client';

import { useContext, useEffect, useState } from 'react';

import { __RouterContext } from 'react-router';

const useReactRouterPageCheck = (): boolean => {
    const [isReactRouter, setIsReactRouter] = useState<boolean>(false);
    const reactRouterContext = useContext(__RouterContext);

    useEffect(
        () => {
            setIsReactRouter(!!reactRouterContext);
        }, // TODO: check or fix hooks error
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return isReactRouter;
};

export default useReactRouterPageCheck;
